module.exports = __webpack_public_path__ + "Roboto-normal-400.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Roboto-normal-400.woff
// module id = 905
// module chunks = 2